import React from "react";

const SubCategoryIntro = ({ campaign }) => {
  if (!campaign) return null;

  return (
    <section className="Introduce-subcategory">
      {/* Background Image or Video */}
      {campaign.type === "video" ? (
        <video
          className="campaign-bg"
          src={campaign.media}
          autoPlay
          loop
        //   muted
          playsInline
        ></video>
      ) : (
        <img className="intro-bg" src={campaign.media} alt={campaign.title} />
      )}

      {/* Overlay */}
      <div className="intro-overlay"></div>

      {/* Campaign Content */}
      <div className="campaign-content"  sx={{p: { xs: 100, sm: 50, md: 20 }}}>
        <h2 className="campaign-category">{campaign.category}</h2>
        <h1 className="campaign-title">{campaign.title}</h1>
        {/* <p className="campaign-description">{campaign.description}</p> */}

        {/* Optional audio control */}
        {campaign.type === "audio" && (
          <audio className="campaign-audio" controls src={campaign.media}></audio>
        )}

        {/* <button className="campaign-btn">Learn More</button> */}
      </div>
    </section>
  );
};

export default SubCategoryIntro;